import { Clock, LogOut } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

const fmt = (s) => {
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
};

export const IdleWarningDialog = ({ seconds, onStay, onLogout }) => {
  return (
    <AlertDialog open>
      <AlertDialogContent className="sm:max-w-md" data-testid="idle-warning-dialog">
        <AlertDialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
            <Clock className="h-6 w-6 text-blue-600" />
          </div>
          <AlertDialogTitle className="text-center">Are you still there?</AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            For your security you'll be signed out due to inactivity in{" "}
            <span className="font-semibold text-blue-600 tabular-nums" data-testid="idle-countdown">
              {fmt(Math.max(0, seconds))}
            </span>
            .
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center gap-2">
          <Button
            variant="outline"
            onClick={onLogout}
            data-testid="idle-logout-now"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </Button>
          <Button
            onClick={onStay}
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="idle-stay-signed-in"
          >
            Stay signed in
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IdleWarningDialog;
